module.exports = __webpack_public_path__ + "static/Jackfrucht-73b15ec5e4c47d4cb428e23389c67962.png";